/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { createContext, Dispatch, ReactNode, SetStateAction, useContext, useState } from "react";

const AccordionGroupContext = createContext<{
  activeAccordionId: string | null;
  setActiveAccordionId: Dispatch<SetStateAction<string | null>>;
} | null>(null);

export const useOptionalAccordionGroup = () => {
  return useContext(AccordionGroupContext);
};

export const useAccordionGroup = () => {
  const context = useContext(AccordionGroupContext);

  if (!context) {
    throw new Error("useAccordionGroup can only be used inside AccordionGroupProvider");
  }

  return context;
};

export type AccordionGroupProviderProps = {
  children: ReactNode;
  defaultActiveId?: string | null;
};

export default function AccordionGroupProvider({ children, defaultActiveId = null }: AccordionGroupProviderProps) {
  const [activeAccordionId, setActiveAccordionId] = useState<string | null>(defaultActiveId);

  return <AccordionGroupContext.Provider value={{ activeAccordionId, setActiveAccordionId }}>{children}</AccordionGroupContext.Provider>;
}
